import {ref} from 'vue';

const query = ref({});

function setQuery(data) {
  query.value = data; /* shareCode, a */
}

function cleanQuery(data) {
  query.value = {};
}

export function useAppleQuery() {
  return {
    query,
    setQuery,
    cleanQuery,
  };
}
